import { history } from '@umijs/max';
import Cookies from 'js-cookie';

export const redirectToSignIn = () => {
  const { pathname, search, hash } = history.location;

  Cookies.remove(TOKEN_NAME, {
    path: '',
    domain: '.' + window.location.hostname,
  });

  location.replace(
    `${SIGN_IN_PATH}?redirect=${encodeURIComponent(pathname + search + hash)}`,
  );
};
